module.exports = __webpack_public_path__ + "static/media/IMG_1818.6206e8bc.JPG";